import React from "react";
import { NavLink } from "react-router-dom";
import { MdExpandMore } from "react-icons/md";

const NavMenu = ({ data }) => (
  <div className="hidden lg:flex items-center space-x-2 xl:space-x-4 font-semibold">
    {data.map((item, index) =>
      item.dropdown ? (
        <div
          key={index}
          className="inline-block px-2 xl:px-4 py-9 relative group text-black hover:text-gray-600 cursor-pointer"
        >
          <div className="flex items-center space-x-1">
            <span className="whitespace-nowrap text-sm xl:text-base">{item.name}</span>
            <MdExpandMore className="transition-transform duration-200 group-hover:rotate-180" />
          </div>
          {/* Smart responsive dropdown */}
          <div className={`absolute top-full mt-2 w-44 bg-white border border-gray-200 shadow-xl rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50 overflow-hidden
                          ${item.name === "Our Services" ? 
                            "right-0 lg:right-0 xl:left-1/2 xl:transform xl:-translate-x-1/2" : 
                            "left-1/2 transform -translate-x-1/2"
                          }
                          before:content-[''] before:absolute before:-top-2 
                          ${item.name === "Our Services" ? 
                            "before:right-6 xl:before:left-1/2 xl:before:right-auto xl:before:transform xl:before:-translate-x-1/2" : 
                            "before:left-1/2 before:transform before:-translate-x-1/2"
                          }
                          before:border-l-8 before:border-r-8 before:border-b-8 before:border-transparent before:border-b-white`}>
            {item.submenu.map((subitem, subindex) => (
              <NavLink
                key={subindex}
                to={subitem.url}
                className={({ isActive }) =>
                  `block px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200 whitespace-nowrap first:rounded-t-lg last:rounded-b-lg ${
                    isActive ? "text-blue-600 bg-blue-50 font-medium border-r-2 border-blue-600" : ""
                  }`
                }
              >
                {subitem.name}
              </NavLink>
            ))}
          </div>
        </div>
      ) : item.name === "Contact Us" ? (
        <NavLink
          key={index}
          to={item.url}
          className="flex px-4 xl:px-6 items-center justify-center py-3 hover:text-gray-200 cursor-pointer bg-blue-800 hover:bg-blue-900 text-white rounded-lg transition-all duration-200 transform hover:scale-105 shadow-md whitespace-nowrap text-sm xl:text-base"
        >
          {item.name}
        </NavLink>
      ) : (
        <NavLink
          key={index}
          to={item.url}
          className={({ isActive }) =>
            `px-2 xl:px-4 py-9 text-black hover:text-gray-600 transition-colors duration-200 border-b-2 border-transparent hover:border-blue-300 whitespace-nowrap text-sm xl:text-base ${
              isActive ? "text-blue-900 border-blue-600 font-medium" : ""
            }`
          }
        >
          {item.name}
        </NavLink>
      )
    )}
  </div>
);

export default NavMenu;
